import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { cloneDeep } from 'lodash';
import { Footer } from '../models/footer';
import { Menu } from '../models/menu';
import { Page } from '../models/page';
import { PageRequest } from '../models/page-request';

export class DynamicStateModel {

  page: Page | null = null;

  menu: Menu | null = null;

  footer: Footer | null = null;
}

export class SetPage {
  static readonly type: string = '[Dynamic] SetPage';

  constructor(public page: Page | null) { }
}

export class SetMenu {
  static readonly type: string = '[Dynamic] SetMenu';

  constructor(public menu: Menu | null) { }
}

export class SetFooter {
  static readonly type: string = '[Dynamic] SetFooter';
  constructor(public footer: Footer) { }
}

export class ResetDynamicState {
  static readonly type: string = '[Dynamic] ResetMainState';
}

@State<DynamicStateModel>({
  name: 'dynamic',
  defaults: new DynamicStateModel(),
})
@Injectable()
export class DynamicState implements NgxsOnInit {
  @Action(SetPage)
  setPage(ctx: StateContext<DynamicStateModel>, action: SetPage): void {
    ctx.patchState({ page: action.page });
  }

  @Action(SetMenu)
  setMenu(ctx: StateContext<DynamicStateModel>, action: SetMenu): void {
    ctx.patchState({ menu: action.menu });
  }

  @Action(SetFooter)
  setFooter(ctx: StateContext<DynamicStateModel>, action: SetFooter): void {
    ctx.patchState({ footer: action.footer });
  }

  @Action(ResetDynamicState)
  resetMainState(ctx: StateContext<DynamicStateModel>, action: ResetDynamicState): void {
    const newState = new DynamicStateModel();
    ctx.setState(newState);
  }

  @Selector()
  static page(state: DynamicStateModel): Page | null {
    return state.page;
  }

  @Selector()
  static menu(state: DynamicStateModel): Menu | null {
    return state.menu;
  }

  @Selector()
  static footer(state: DynamicStateModel): Footer | null {
    return state.footer;
  }

  ngxsOnInit(): void {
  }
}
